module.exports = __webpack_public_path__ + "img/2x.f5e83b5.jpg";